import makeApiCall from "../master/axiosIndex";
const STATIC_FILES_DATA = [
  {
    order: 0,
    module: "RA Bill",
    moduleFileType: "signature.png",
  }
];

const RABillApis = {
  listRABill: (params: any) =>
    makeApiCall({
      url: "/ra-bill/list",
      method: "get",
      params,
    }),
  approveRABill: (raBillId: number, files: File[] = []): Promise<any> => {
    const formData = new FormData();

    const requestBody = {
      raBillId,
      filesData: STATIC_FILES_DATA,
    };

    formData.append("raBill", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));

    return makeApiCall<any>({
      method: "post",
      url: `/ra-bill/approve`,
      data: formData,
    });
  },

  rejectRABill: (raBillId: number, reason: string, files: File[] = []): Promise<any> => {
    const formData = new FormData();

    const requestBody = {
      raBillId,
      reason,
      filesData: STATIC_FILES_DATA,
    };

    formData.append("raBill", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));

    return makeApiCall<any>({
      method: "post",
      url: `/ra-bill/reject`,
      data: formData,
    });
  },
  getRABillById: (raBillId: any) =>
    makeApiCall({
      url: `/ra-bill/id/${raBillId}`,
      method: "get",
    }),
  createRABill: (data: any) =>
    makeApiCall({
      url: "/ra-bill/create",
      method: "post",
      data,
    }),
  bulkUploadRABill: (formData: FormData) =>
    makeApiCall({
      url: "/ra-bill/bulk-upload",
      method: "post",
      data: formData,
      // headers: {
      //   "Content-Type": "multipart/form-data",
      // },
    }),
};

export default RABillApis;
